var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneBright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 33.8402V39.8402C44.0024 40.3972 43.8883 40.9485 43.6651 41.4589C43.442 41.9692 43.1147 42.4274 42.7043 42.8039C42.2938 43.1805 41.8093 43.4672 41.2816 43.6456C40.754 43.8241 40.1949 43.8903 39.6401 43.8402C33.4858 43.1715 27.5741 41.0685 22.3801 37.7002C17.5478 34.6295 13.4508 30.5325 10.3801 25.7002C7.00007 20.4826 4.8966 14.5422 4.24011 8.36019C4.19013 7.80713 4.25586 7.24971 4.43311 6.72344C4.61036 6.19717 4.89525 5.71357 5.26964 5.30344C5.64403 4.8933 6.09972 4.56561 6.60769 4.34124C7.11566 4.11686 7.66479 4.00072 8.22011 4.00019H14.2201C15.1907 3.99064 16.1317 4.33435 16.8676 4.96726C17.6036 5.60017 18.0843 6.47909 18.2201 7.44019C18.4734 9.36033 18.943 11.2456 19.6201 13.0602C19.8892 13.776 19.9474 14.554 19.7879 15.302C19.6284 16.0499 19.2578 16.7364 18.7201 17.2802L16.1801 19.8202C19.0272 24.8273 23.173 28.9731 28.1801 31.8202L30.7201 29.2802C31.2639 28.7425 31.9504 28.3719 32.6983 28.2124C33.4463 28.0529 34.2243 28.1111 34.9401 28.3802C36.7547 29.0573 38.64 29.5269 40.5601 29.7802C41.5316 29.9173 42.4189 30.4066 43.0532 31.1552C43.6874 31.9038 44.0244 32.8593 44.0001 33.8402Z",
    stroke: "#666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBright);
export default __webpack_public_path__ + "static/media/PhoneBright.f2706f72caf7c22f434194a60323c6c9.svg";
export { ForwardRef as ReactComponent };